import { gql } from "apollo-boost"

export const ADD_BENEFICIARY_PROFILE_TO_PROJECT_BENEFICIARY = gql`
  mutation addBeneficiaryProfileToProjectBeneficiary ($projectBeneficiaryID: ID!, $beneficiaryProfileID: ID!, $status: String!) {
    AddBeneficiaryProfileToProjectBeneficiary(
      projectBeneficiaryID: $projectBeneficiaryID, 
      beneficiaryProfileID:$beneficiaryProfileID,
      status: $status
      )
  }
`